import {parseSettings} from "./ganttWrapper/Settings/parseSettings";
import {createGantt} from "./ganttWrapper/ganttWrapper";
import moment from "moment";
import createElement from "../../../helpers/createElement";
import {waitUntil} from "../../../helpers/waitUntil";

// noinspection JSValidateTypes
/**
 * @param {Element} formElement
 * @param {Timeline.FormSettings} formSettings
 * @return {Timeline.Form}
 */
function initViewOnlyTimelineForm(formElement, formSettings = {}) {
	const dateFormat = 'MM/DD/YYYY';

	// Init gantt display
	let tasks = [
		{
			id: '-1',
			name: 'Initial Task',
			start: '2023-01-01',
			end: '2023-01-31',
			duration: 365,
			dependencies: [],
			constraints: [],
			delays: [],
			progress: 0,
			is_milestone: false,
			printable: false,
		},
	];

	// Check if we have existing tasks
	const tasksInput = formElement.querySelector('input[name="existing_tasks"]');
	try {
		/**
		 * @type {GanttWrapper.Task[]}
		 */
		const existingTasks = JSON.parse(tasksInput.value);

		// Parse delays
		existingTasks.forEach(task => {
			task.delays.forEach(delay => {
				// Parse start date
				if (delay.startDate) {
					delay.startDate = moment(delay.startDate, 'YYYY-MM-DD');
				}
			})
		})

		tasks = tasks.concat(existingTasks);
	} catch (e) {
		// Couldn't parse existing tasks
		alert('Error retrieving tasks')
		console.log(e);
	}

	// Retrieve timeline settings
	/** @type {TimelineSettingsDefs.Settings} */
	let settings;
	try {
		settings = parseSettings(
			formElement.querySelector('input[name="settings"]').value
		);
	} catch (e) {
		// Couldn't parse existing tasks
		alert('Error retrieving timeline settings')
		console.log(e);
	}

	const gantt = createGantt(
		formElement.querySelector('.gantt-wrapper-container'),
		tasks,
		settings,
		{
			viewOnly: true,
			forAdminLayout: formSettings.forAdminLayout,
			getPrintWindowHtmlRoute: formElement.querySelector('input[name="get_print_window_html_route"]').value,
			printTaskSheetRoute: formElement.querySelector('input[name="print_task_sheet_route"]').value,
		}
	)

	// Init current tasks display
	const currentTaskDisplay = formElement.querySelector('.current-tasks-container');
	const currentTaskContainer = currentTaskDisplay.querySelector('.scroll-wrapper');

	// Get current tasks
	const currentTasks = gantt._getCurrentTasks();

	currentTasks.forEach(currentTask => {
		// Get up to 2 parent tasks
		let taskTree = gantt._getTaskParents(currentTask).slice(0, 2);

		// Reorder and append current task to the end
		taskTree = taskTree.reverse().concat(currentTask);

		// Print on container
		taskTree.forEach((task, index) => {
			const isCurrentTask = task === currentTask;

			let iconHtml = isCurrentTask ?
				'<i class="mdi mdi-calendar-today"></i>' :
				'';

			const taskElement = createElement(`
				<div style="padding-left: ${12 * index}px">
					<a
						class="${isCurrentTask ? '' : 'text-muted'}"
						href="#"
					>
						${task.name} ${iconHtml}
					</a>
				</div>
			`);

			// Add click handler to focus task on gantt
			taskElement.querySelector('a').addEventListener('click', (e) => {
				e.preventDefault();
				gantt._focusTask(task);
			})

			currentTaskContainer.appendChild(taskElement);
		})
	})

	if (currentTasks.length) {
		// Hide empty warning
		currentTaskDisplay.querySelector('.empty-message').classList.add('d-none');
	}

	currentTaskDisplay.classList.add('initialized')

	// Init project milestones
	const projectMilestonesDisplay = formElement.querySelector('.project-milestones');
	const projectMilestonesContainer = projectMilestonesDisplay.querySelector('.scroll-wrapper');

	// Get milestones
	const milestoneTasks = gantt._getTasks().filter(task => {
		return task.is_milestone;
	})

	milestoneTasks.forEach(milestone => {
		const startDate = gantt._getCurrentStartDate(milestone);
		const endDate = gantt._getCurrentEndDate(milestone);
		const dateString = startDate.isBefore(endDate) ?
			`${startDate.format(dateFormat)} - ${endDate.format(dateFormat)}` :
			startDate.format(dateFormat);

		const milestoneTaskContainer = createElement(`
			<a class="milestone-task d-flex justify-content-between" href="#">
				<div>
					${milestone.name}
				</div>
				<div class="text-muted">
					${dateString}
				</div>
			</a>
		`)

		milestoneTaskContainer.addEventListener('click', (e) => {
			e.preventDefault();
			gantt._focusTask(milestone);
		})

		projectMilestonesContainer.appendChild(milestoneTaskContainer);
	})

	if (milestoneTasks.length) {
		// Hide empty warning
		projectMilestonesDisplay.querySelector('.empty-message').classList.add('d-none');
	}

	projectMilestonesDisplay.classList.add('initialized')

	if (formSettings.focusTask) {
		// Wait until initialization to scroll gantt
		waitUntil(() => gantt._container.classList.contains('initialized'))
			.then(() => {
				setTimeout(() => {
					// Wait an extra bit just in case
					// to make sure the css animations play out
					gantt._focusTask(gantt._findTaskById(formSettings.focusTask));
				}, 512)
			})
	}
}

export {initViewOnlyTimelineForm}
